import type { Table as TableType } from '@tanstack/react-table'
import { Fragment } from 'react'

import { DataTableHeader } from './DataTableHeader'
import type { TableData } from './types'

interface DataTableHeadersProps {
  table: TableType<TableData>
}

export const DataTableHeaders = function DataTableHeaders({
  table,
}: DataTableHeadersProps) {
  const headerGroups = table.getHeaderGroups()

  return (
    <div className="flex items-center px-4 w-(--table-width)">
      {headerGroups.map((headerGroup) => (
        <Fragment key={headerGroup.id}>
          {headerGroup.headers.map((header) => (
            <DataTableHeader key={header.id} header={header} />
          ))}
        </Fragment>
      ))}
    </div>
  )
}
